import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { Dialog, FormControlLabel, FormGroup } from "@mui/material";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { DateTimePicker } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "./css/table.css";
import Checkbox from "@mui/material/Checkbox";
import ButtonAppBar from "./ButtonAppBar";
import SplitButton from "./meetingRoom/ButtonSplit";
import Button from "@mui/material/Button";
function Insert() {
  const [name, setName] = useState(""); // 담당자 이름
  const [department, setDepartment] = useState(""); // 부서
  const [subject, setSubject] = useState(""); // 내용
  const [startTime, setStartTime] = useState(null); // 시작시간
  const [endTime, setEndTime] = useState(null); // 종료시간
  const [phoneNumber, setPhoneNumber] = useState("");
  const [checked, setChecked] = useState(false);
  const [email, setEmail] = useState("");
  const [roomNum, setRoomNum] = useState(1);
  const apiUrl = process.env.REACT_APP_API;

  const flagChange = (event) => {
    setChecked(event.target.checked);
  };
  const handlePhoneNumberChange = (e) => {
    let input = e.target.value;

    // 숫자만 남기고 나머지 문자 제거
    input = input.replace(/\D/g, "");

    // 번호를 하이픈(-)으로 포맷
    if (input.length > 4 && input.length <= 8) {
      input = input.replace(/(\d{3})(\d+)/, "$1-$2");
    } else if (input.length > 8) {
      input = input.replace(/(\d{3})(\d{4})(\d+)/, "$1-$2-$3");
    }

    setPhoneNumber(input);
  };

  const handleSubmit = () => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    if (email === "" || !emailPattern.test(email)) {
      alert("올바른 이메일 주소를 입력하세요");
    } else {
      const requestData = {
        roomSid: roomNum,
        reservationPart: department,
        reservationName: name,
        reservationPhone: phoneNumber,
        reservationSubject: subject,
        reservationStartTime: startTime,
        reservationEndTime: endTime,
        usableFlag: "Y",
        createUserId: sessionStorage.getItem("id"),
        approveFlag: "Y",
        executiveFlag: checked ? "Y" : "N",
        userEmail: email,
      };

      fetch(`${apiUrl}/mr/reservation`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          window.location.replace("/reservation");
          return response.json(); // 서버 응답을 JSON으로 파싱
        })
        .then((responseData) => {
          // 성공적인 응답 처리
          console.log("Server response:", responseData);
          // TODO: 필요한 작업 수행 (예: 다이얼로그 닫기 등)
        })
        .catch((error) => {
          // 오류 처리 (네트워크 오류 또는 서버 오류 등)
          console.error("Error:", error);
        });
    }
  };

  const roomType = (roomNum) => {
    if (roomNum === 0) {
      setRoomNum(1);
    } else if (roomNum === 1) {
      setRoomNum(2);
    }
  };

  return (
    <Box>
      <ButtonAppBar />
      <Paper
        sx={{ p: 1, display: "flex", flexDirection: "column", width: "95%" }}
      >
        <Grid
          sx={{ paddingRight: "5px", paddingLeft: "5px", marginTop: "40px" }}
          container
          spacing={2}
        >
          <Grid sx={{ marginTop: "18px" }} item xs={6} sm={6}>
            <SplitButton num={roomType} />
          </Grid>
          <Grid item xs={6} sm={6}>
            <FormGroup>
              <FormControlLabel
                label="임원참석여부"
                control={<Checkbox checked={checked} onChange={flagChange} />}
                sx={{ paddingTop: 1.5 }}
              />
            </FormGroup>
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              required
              id="name"
              name="name"
              label="담당자"
              fullWidth
              variant="standard"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              required
              id="name"
              name="name"
              label="부서"
              fullWidth
              variant="standard"
              value={department}
              onChange={(e) => setDepartment(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="phone"
              name="phone"
              label="전화번호"
              fullWidth
              variant="standard"
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
              inputProps={{
                maxLength: 13, // 하이픈 포함 최대 길이
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              id="subject"
              name="subject"
              label="사유"
              fullWidth
              variant="standard"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="email"
              name="email"
              label="이메일"
              fullWidth
              variant="standard"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DateTimePicker"]}>
                <DateTimePicker
                  label="시작시간"
                  value={startTime}
                  onChange={(value) => setStartTime(value)}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DateTimePicker"]}>
                <DateTimePicker
                  label="종료시간"
                  value={endTime}
                  onChange={(value) => setEndTime(value)}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button
              sx={{ width: "100%" }}
              onClick={(e) => {
                e.stopPropagation();
                handleSubmit();
              }}
              variant="contained"
            >
              예약하기
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}
export default Insert;
